import { WISHLIST_EVENT, SEND_EVENT } from '@/js/analytics/const'

export default function sendWishlistItems(id, price, isInStock) {
  console.log('sendWishlistItems', price);
  if ('undefined' === typeof window.eS) return false
  // eslint-disable-next-line no-undef
  eS(SEND_EVENT, WISHLIST_EVENT, {
    [WISHLIST_EVENT]: {
      productKey: id,
      price,
      isInStock,
    },
  })
  return false
}
